import { z } from 'zod';
import type { WorkerProfile } from '@/types/session';

const key = 'abako-developer-signup-draft';
const text = z.string().max(4096).nullable();
const schema = z.object({
  principalId: z.string().nullable(),
  username: z.string().max(64),
  profile: z.object({
    name: z.string().max(128),
    contactEmail: text,
    githubUsername: text,
    portfolioUrl: text,
    biography: text,
    background: text,
    proficiency: z.enum(['junior', 'mid-level', 'senior']).nullable(),
    roleExperiences: z
      .array(
        z.object({
          roleId: z.number().int().positive().max(0xffffffff),
          proficiency: z.enum(['junior', 'mid-level', 'senior']),
        })
      )
      .max(64)
      .optional(),
    location: text,
    languages: z.array(z.string().max(64)).max(32),
  }),
  roleIds: z.array(z.number().int().positive()).max(256),
  skillIds: z.array(z.number().int().positive()).max(256),
  hours: z.number().int().min(0).max(168),
  imageSelected: z.boolean(),
});
export interface SignupDraft {
  principalId: string | null;
  username: string;
  profile: WorkerProfile;
  roleIds: number[];
  skillIds: number[];
  hours: number;
  imageSelected: boolean;
}
export function readSignupDraft(): SignupDraft | null {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;
    const parsed = schema.safeParse(JSON.parse(raw));
    return parsed.success ? parsed.data : null;
  } catch {
    return null;
  }
}
export function saveSignupDraft(draft: SignupDraft): void {
  // Schema strips unknown fields: passwords and files never reach storage.
  try {
    sessionStorage.setItem(key, JSON.stringify(schema.parse(draft)));
  } catch {
    /* The in-memory draft remains usable if tab storage is unavailable. */
  }
}
export function clearSignupDraft(): void {
  try {
    sessionStorage.removeItem(key);
  } catch {
    /* Session-scoped storage can be unavailable in privacy modes. */
  }
}
